import { ContainerComponent, wrap } from 'AppReact';
import {
  FlexCenterWrapper, CursorPointerWrapper, Mr3, FitRelativeWrapper,
  AbsoluteLeftTopWrapper, CustomBorderWrapper, FilterHeaderWrapper,
  Mr2, Mt4, FlexCenterJustifyEndWrapper, Width350
} from 'wrappers';
import { Icon, SecondaryTextSm, PrimaryTextSm, SecondaryTextXs } from 'atoms';
import { IconTextButton } from 'molecules';
import {
  MoreFiltersSvg,
  HammerSvg,
  CheckboxSvg,
  LockSvg,
  ClockSvg,
  ListColsSvg,
  HomeSvg,
  WarningTriangleSvg,
  TrashBinSvg,
  ExclamationMarkSvg,
  RefreshArrowSvg
} from 'components/icons';
import React from 'react';
import internalState from './internalState';
import Controller from './controller';
import BoxDropdown from '../boxDropdown';

const containerRef = React.createRef();

export const definition = {
  name: 'WorkOrdersFilters',
  controller: Controller,
  initialProps: ({
    selectedCategoryIds,
    selectedUnitIds,
    priorities,
    selectedPriorityIds,
    waitingOnParts,
    noAccess,
    isCallback,
    activeOrders,
    postErrorOrders,
    units,
    categories,
    selectedTab
  }) => ({
    selectedCategoryIds,
    selectedUnitIds,
    priorities,
    selectedPriorityIds,
    waitingOnParts,
    noAccess,
    activeOrders,
    postErrorOrders,
    isCallback,
    units,
    categories,
    selectedTab
  }),
  props: internalState,
  elements: [
    {
      wrapper: FitRelativeWrapper,
      name: 'Wrapper',
      ref: containerRef,
      elements: [
        {
          wrapper: wrap(FlexCenterWrapper, CursorPointerWrapper),
          name: 'HeaderWrapper',
          isButton: true,
          bindings: ({
            isOpen,
            selectedCategoryIds,
            selectedUnitIds,
            priorities,
            selectedPriorityIds,
            waitingOnParts,
            noAccess,
            isCallback,
            activeOrders,
            postErrorOrders
          }) => ({
            isOpen,
            containerRef,
            selectedCategoryIds,
            priorities,
            selectedPriorityIds,
            selectedUnitIds,
            waitingOnParts,
            noAccess,
            isCallback,
            activeOrders,
            postErrorOrders
          }),
          elements: [
            {
              component: wrap(Icon, Mr3),
              name: 'Icon',
              displayValue: ({ }) => MoreFiltersSvg({})
            },
            {
              component: SecondaryTextSm,
              renderIf: ({ isOpen }) => !isOpen,
              name: 'Text',
              displayValue: ({ }) => 'More filters'
            },
            {
              component: PrimaryTextSm,
              renderIf: ({ isOpen }) => isOpen,
              name: 'Text',
              displayValue: ({ }) => 'More filters'
            }
          ]
        },
        {
          wrapper: AbsoluteLeftTopWrapper,
          displayState: ({ }) => ({ top: '30px' }),
          renderIf: ({ isOpen }) => isOpen,
          name: 'DropdownWrapper',
          elements: [
            {
              wrapper: CustomBorderWrapper,
              name: 'BorderWrapper',
              displayState: ({ }) => ({
                borderRadius: '8px',
                border: '1px solid #E3E3E3',
                background: '#FFFFFF',
                padding: '12px'
              }),
              elements: [
                {
                  component: BoxDropdown,
                  name: 'Category',
                  bindings: ({ selectedCategoryIds, categories }) => {
                    const entries = [];
                    categories.map((c) => {
                      c.children.map((c) => entries.push({ id: c.id, label: c.name }));
                    });
                    return {
                      label: 'Category',
                      icon: ListColsSvg({ selected: true, width: 15, height: 15 }),
                      selectedIds: selectedCategoryIds ?? [],
                      entries
                    };
                  }
                },
                {
                  component: wrap(BoxDropdown, Mt4),
                  name: 'Priority',
                  bindings: ({ selectedPriorityIds, priorities }) => {
                    const entries = priorities.map((u) => ({ id: u.id, label: u.name.toUpperCase()}));
                    return {
                        label: 'Priority',
                        icon: WarningTriangleSvg({}),
                        selectedIds: selectedPriorityIds ?? [],
                        entries
                      }
                    }
                },
                {
                  component: wrap(wrap(BoxDropdown, Width350), Mt4),
                  name: 'Unit',
                  bindings: ({ selectedUnitIds, units }) => {
                    const entries = units.map((u) => ({ id: u.id, label: `${u.number} - ${u.property ?? ''}` }));
                    return {
                      label: 'Unit',
                      icon: HomeSvg({ width: 15, height: 15 }),
                      selectedIds: selectedUnitIds ?? [],
                      entries
                    };
                  }
                },
                {
                  wrapper: wrap(FilterHeaderWrapper, Mt4),
                  name: 'WaitingOnParts',
                  renderIf: ({ selectedTab }) => selectedTab !== 'recurring',
                  isButton: true,
                  bindings: ({ waitingOnParts }) => ({ waitingOnParts }),
                  elements: [
                    {
                      wrapper: FlexCenterWrapper,
                      name: 'LeftSide',
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => HammerSvg({
                            width: 14,
                            height: 14,
                            color: `${window.settings?.primary_color ?? '#1DBD6B'}`
                          })
                        },
                        {
                          component: SecondaryTextXs,
                          name: 'Label',
                          displayValue: ({ }) => 'Waiting on parts'
                        }
                      ]
                    },
                    {
                      component: Icon,
                      name: 'Checkbox',
                      displayValue: ({ waitingOnParts }) => CheckboxSvg({ checked: waitingOnParts })
                    }
                  ]
                },
                {
                  wrapper: wrap(FilterHeaderWrapper, Mt4),
                  name: 'NoAccess',
                  renderIf: ({ selectedTab }) => selectedTab !== 'recurring',
                  isButton: true,
                  bindings: ({ noAccess }) => ({ noAccess }),
                  elements: [
                    {
                      wrapper: FlexCenterWrapper,
                      name: 'LeftSide',
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => LockSvg({
                            width: 14,
                            height: 14,
                            color: `${window.settings?.primary_color ?? '#1DBD6B'}`
                          })
                        },
                        {
                          component: SecondaryTextXs,
                          name: 'Label',
                          displayValue: ({ }) => 'No access'
                        }
                      ]
                    },
                    {
                      component: Icon,
                      name: 'Checkbox',
                      displayValue: ({ noAccess }) => CheckboxSvg({ checked: noAccess })
                    }
                  ]
                },
                {
                  wrapper: wrap(FilterHeaderWrapper, Mt4),
                  name: 'IsCallback',
                  renderIf: ({ selectedTab }) => selectedTab !== 'recurring',
                  isButton: true,
                  bindings: ({ isCallback }) => ({ isCallback }),
                  elements: [
                    {
                      wrapper: FlexCenterWrapper,
                      name: 'LeftSide',
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => RefreshArrowSvg({
                            width: 14,
                            height: 14,
                            color: `${window.settings?.primary_color ?? '#1DBD6B'}`
                          })
                        },
                        {
                          component: SecondaryTextXs,
                          name: 'Label',
                          displayValue: ({ }) => 'Is callback'
                        }
                      ]
                    },
                    {
                      component: Icon,
                      name: 'Checkbox',
                      displayValue: ({ isCallback }) => CheckboxSvg({ checked: isCallback })
                    }
                  ]
                },
                {
                  wrapper: wrap(FilterHeaderWrapper, Mt4),
                  name: 'ActiveOrders',
                  renderIf: ({ selectedTab }) => selectedTab !== 'recurring' && window.settings.technician_timer_clock,
                  isButton: true,
                  bindings: ({ activeOrders }) => ({ activeOrders }),
                  elements: [
                    {
                      wrapper: FlexCenterWrapper,
                      name: 'LeftSide',
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => ClockSvg({
                            width: 14,
                            height: 14,
                            color: `${window.settings?.primary_color ?? '#1DBD6B'}`
                          })
                        },
                        {
                          component: SecondaryTextXs,
                          name: 'Label',
                          displayValue: ({ }) => 'Active Orders'
                        }
                      ]
                    },
                    {
                      component: Icon,
                      name: 'Checkbox',
                      displayValue: ({ activeOrders }) => CheckboxSvg({ checked: activeOrders })
                    }
                  ]
                },
                {
                  wrapper: wrap(FilterHeaderWrapper, Mt4),
                  name: 'PostError',
                  renderIf: ({ selectedTab }) => selectedTab !== 'recurring',
                  isButton: true,
                  bindings: ({ postErrorOrders }) => ({ postErrorOrders }),
                  elements: [
                    {
                      wrapper: FlexCenterWrapper,
                      name: 'LeftSide',
                      elements: [
                        {
                          component: wrap(Icon, Mr2),
                          name: 'Icon',
                          displayValue: ({ }) => ExclamationMarkSvg({
                            width: 14,
                            height: 14,
                            color: `${window.settings?.primary_color ?? '#1DBD6B'}`
                          })
                        },
                        {
                          component: SecondaryTextXs,
                          name: 'Label',
                          displayValue: ({ }) => 'Post Errors Only'
                        }
                      ]
                    },
                    {
                      component: Icon,
                      name: 'Checkbox',
                      displayValue: ({ postErrorOrders }) => CheckboxSvg({ checked: postErrorOrders })
                    }
                  ]
                },
                {
                  component: wrap(wrap(IconTextButton, Mt4), FlexCenterJustifyEndWrapper),
                  name: 'ResetFilters',
                  bindings: ({ }) => ({ icon: TrashBinSvg({}), title: 'Clear filters' })
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};

export default ContainerComponent(definition);
